/* verqo — Seller Landing TRIMMED preview (Feb 2026)
   Renders the real LandingV2Preview with:
     - Built-in floating header suppressed (mega-menu header used instead)
     - Sections destined for sub-pages hidden:
       · section-portals   → moved to /company/how-it-works
       · section-compare   → moved to /company/why
       · section-coming-soon → moved to /company/how-it-works bottom
   Buyer-related sections + full pricing kept at full size (per user brief).
*/
import { PreviewNavHeader } from "../../../components/marketing/PreviewNavHeader";
import { PreviewFooter } from "../../../components/marketing/PreviewFooter";
import LandingV2Preview from "../LandingV2Preview";

export default function SellerLandingTrimmed() {
  return (
    <div className="min-h-screen bg-white">
      <PreviewNavHeader modeOverride="seller" />
      <div data-testid="seller-landing-trimmed-body">
        <LandingV2Preview theme="tier1" hideBanner trimmedForPreview />
      </div>
      <PreviewFooter modeOverride="seller" />
    </div>
  );
}
